import React from "react";
const HeadWise = ({ data }) => {
  return <div>Head Wise</div>;
};
export default HeadWise;
